export const STORAGE_KEY = {
  QUESTIONNAIRE: {
    INITIAL: "initialQuestionnaire_PublicForms",
    FOLLOW_UP: "followUpQuestionnaire_PublicForms",
    INITIAL_ORTHO_EXTREMITIES:
      "initialOrthoExtremitiesQuestionnaire_PublicForms",
    FOLLOW_UP_ORTHO_EXTREMITIES:
      "followUpOrthoExtremitiesQuestionnaire_PublicForms",
  },
};
